export default {
  videoEls: document.querySelectorAll('.js-video'),
  init() {
    if (!this.videoEls.length) {
      return;
    }

    this.videoEls.forEach((el) => {
      const video = el.querySelector('video');
      const overlay = el.querySelector('.overlay');
      const image = el.querySelector('.atom-image');

      if (!video || !overlay) {
        return;
      }

      overlay.addEventListener('click', () => {
        video.play();
        video.setAttribute('controls', '');
        overlay.classList.add('hide');
        if (image) {
          setTimeout(() => {
            image.classList.add('hide');
          }, 200);
        }
      });

      video.addEventListener('ended', () => {
        overlay.classList.remove('hide');
        video.removeAttribute('controls');

        if (image) {
          image.classList.remove('hide');
        }
      });

      video.addEventListener('pause', () => {
        if (video.seeking) return;
        overlay.classList.remove('hide');
        video.removeAttribute('controls');
      });
    });
  },
};
